<!--
 * @Author: your name
 * @Date: 2020-09-23 13:47:16
 * @LastEditTime: 2020-10-21 17:01:28
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit  
 * @FilePath: \vue-gaokao-ebook\src\components\alig2Charts\pieChart.vue
-->
<template>
  <div id="container" class="pie-container" />
</template>

<script>
import { Chart } from "@antv/g2";
import { DataSet } from '@antv/data-set'
export default {
  name:"pieChart",
    //数据部分
  data(){
    return{
      // otherOffsetAngle : 6.67 / 100 * Math.PI,
      // pieChartData : [
      //     { type: '微博', value: 83.33 },
      //     { type: '其他', value: 6.67 },
      // ],
      // pieOtherData : [
      //   { type: '论坛', value: 1.77 },
      //   { type: '网站', value: 1.44 },
      //   { type: '微信', value: 1.12 },
      //   { type: '客户端', value: 1.05 },
      //   { type: '新闻', value: 0.81 },
      //   { type: '视频', value: 0.39 },
      //   { type: '博客', value: 0.37 },
      //   { type: '报刊', value: 0.17 },
      // ],
      chart :{},
      view1 : {},
      view2 : {},
      view3 :{}
    }
  },
  props :{
    pieChartData : {
      type : Array, 
      default : function(){
        return new Array();
      }
    },
    pieOtherData : {
      type : Array,
      default : function(){
        return new Array();
      }
    },
    otherOffsetAngle : {
      type : Number,
      default : 0,
    }
  },
  mounted(){
  },
  watch :{
    pieChartData () {
      if(this.otherOffsetAngle != 0 ){
        this.initChart();
      }
    },
    otherOffsetAngle(){
    }
  },
  methods: {
  drawLinkArea() {
      const canvas = this.chart.getCanvas();
      const container = this.chart.backgroundGroup;
      const view1_coord = this.view1.getCoordinate();
      const center = view1_coord.getCenter();
      const radius = view1_coord.getRadius();
      const interval_geom = this.view2.geometries[0];
      const interval_container = interval_geom.container;
      const interval_bbox = interval_container.getBBox();
      const view2_coord = this.view2.getCoordinate();
      // area points
      const pie_start1 = {
        x: center.x + Math.cos(Math.PI * 2 - this.otherOffsetAngle) * radius,
        y: center.y + Math.sin(Math.PI * 2 - this.otherOffsetAngle) * radius,
      };
      const pie_start2 = {
        x: center.x + Math.cos(this.otherOffsetAngle) * radius,
        y: center.y + Math.sin(this.otherOffsetAngle) * radius,
      };
      const interval_end1 = {
        x: interval_bbox.minX,
        y: view2_coord.end.y,
      };
      const interval_end2 = {
        x: interval_bbox.minX,
        y: view2_coord.start.y,
      };
      const path = [
        ['M', pie_start1.x, pie_start1.y],
        ['L', pie_start2.x, pie_start2.y],
        ['L', interval_end2.x, interval_end2.y],
        ['L', interval_end1.x, interval_end1.y],
        ['Z'],
      ];
      container.addShape('path', {
        attrs: {
          path,
          fill: '#e9f4fe',
        },
      });
      canvas.draw();
    },
    initChart(){
    this.chart =  new Chart({
      container: 'container',
      autoFit: true,
    });
    
    this.view1 = this.chart.createView({
      region: {
        start: {
          x: 0.1,
          y: 0.1,
        },
        end: {
          x: 0.6,
          y: 0.9,
        },
      },
    });

    this.view2 = this.chart.createView({

      region: {
        start: {
          x: 0.6,
          y: 0.1,
        },
        end: {
          x: 0.9,
          y: 0.9,
        },
      },
    });


    this.chart.legend(false);
    this.chart.tooltip({
      showMarkers: false,
    });

    this.view1.coordinate('theta', {
      radius: 0.7,
      startAngle: 0 + this.otherOffsetAngle,
      endAngle: Math.PI * 2 + this.otherOffsetAngle,
    });

    this.view1.data(this.pieChartData);
    this.view1.interaction('element-highlight');
    this.view1
      .interval()
      .adjust('stack')
      .position('value')
      .color('type', ['#02A7F0', '#66CC00'])
      .label('value', function () {
        return {
          offset: -10,
          content: (obj) => {
            return obj.type + '\n' + obj.value + '%';
          },
          
        };
    });

    this.view2.axis(false);
    this.view2.data(this.pieOtherData);
    this.view2.interaction('element-highlight');
    this.view2
      .interval()
      .adjust('stack')
      .position('value')
      .color('type', ['#85D633', '#A3E066', '#C2EB99'])
      .label('value', {
        position: 'right',
        offsetX: 0,
        offsetY: 10,
        content: (obj) => {
          return obj.type + ' ' + obj.value + '%';
        },
    });

    this.chart.render();
    this.drawLinkArea();
          
    this.chart.on('afterpaint', function () {
      this.drawLinkArea();
    });

    
    
    }
  },
  

}
</script>

<style lang="stylus" scoped>
.pie-container{
  width : 800px !important;
  height : 300px !important;
  
}
/deep/ .g2-tooltip-title{
  font-size : 24px !important;
}
/deep/ .g2-tooltip-name{
  font-size : 24px !important;
}
>>> .g2-tooltip{
  font-size : 24px !important;
}
</style>